module.exports = __webpack_public_path__ + "img/exam_jan_2025_5cczvx7p.16777f06.jpg";